import type { OctopusFeatureToggle } from "@octopusdeploy/octopus-server-client";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useOctopusFeatureToggle(toggle: OctopusFeatureToggle, defaultValue: boolean) {
    return useBooleanFlagValue(toggle, defaultValue);
}
export function usePlatformHubOctopusFeatureToggles() {
    const projectTemplates = useBooleanFlagValue("project-templates", false);
    const compliancePolicies = useBooleanFlagValue("compliance-policies", false);
    return { projectTemplates, compliancePolicies };
}
export interface PlatformHubOctopusFeatureToggles {
    projectTemplates: boolean;
    compliancePolicies: boolean;
}
